/* tt-cart: keeps the cart page honest after every change. No Ride internals are called.
   1. "Nog X tot gratis verzending" is recomputed from /cart.js (the tt-ship section is not re-rendered by Ride).
   2. An extra-design line (one per extra design, EUR 5,00 per piece) FOLLOWS its garment line (same _tt_link): garment gone -> the line is removed
      via /cart/change.js, garment quantity changed -> the extra line gets the same quantity (r17extra: Vincent decided "per stuk"), then the page reloads.
   3. Style and size surcharge lines (property _tt_toeslag, same _tt_link as their garment line) FOLLOW the garment line:
      garment gone -> surcharge removed; garment quantity changed -> surcharge quantity set to the same number.
   4. r19deellink: the "Deel met je groep" button under a garment line (navigator.share, else copy the link).
   5. r21wagen: the one "zelfde ontwerp ook op" card shows from the free-shipping threshold on (below it the pet proposal under the bar is the one upsell);
      the phone bar with the total and Afrekenen shows while the real Afrekenen button is out of view; "Wijzig" takes the line out of the cart, then opens its product page. */
(function () {
  'use strict';
  var EXTRA = 'extra-design-toevoegen';
  var timer = null, busy = false, failed = false;

  // Money: the one theme formatter window.ttMoney (layout/theme.liquid), same as the Liquid money filter.
  function eur(c) { return window.ttMoney(c); }

  function ship(cart) {
    var el = document.querySelector('[data-tt-ship-left]');
    if (!el) return;
    el.hidden = cart.item_count === 0;
    var nl = parseInt(el.getAttribute('data-nl-free'), 10) - cart.total_price;
    var be = parseInt(el.getAttribute('data-be-free'), 10) - cart.total_price;
    var t = nl > 0 ? 'Nog ' + eur(nl) + ' tot gratis verzending in Nederland.' : 'Gratis verzending in Nederland.';
    t += be > 0 ? ' Nog ' + eur(be) + ' voor België.' : ' Gratis verzending in België.';
    if (el.textContent.trim() !== t) el.textContent = t;
    // r21wagen: the one card appears at the threshold (nl <= 0), same rule as snippets/tt-zelfde-ontwerp.liquid
    var cards = document.querySelectorAll('[data-tt-zo-cards]');
    for (var i = 0; i < cards.length; i++) cards[i].hidden = !(nl <= 0);
  }

  function showError(msg) {
    var box = document.getElementById('cart-errors');
    if (box) box.textContent = msg;
  }

  function isToeslag(i) { return !!(i.properties && i.properties._tt_toeslag); }

  // The changes the cart needs: [{ key, quantity }]. Pure, so the test can call it with a fixture cart.
  function plan(cart) {
    var main = {};
    cart.items.forEach(function (i) {
      if (i.handle !== EXTRA && !isToeslag(i) && i.properties && i.properties._tt_link) main[i.properties._tt_link] = i;
    });
    var out = [];
    cart.items.forEach(function (i) {
      var link = i.properties && i.properties._tt_link;
      if (!link) return;
      if (i.handle === EXTRA) {
        if (!main[link]) out.push({ key: i.key, quantity: 0 });
        else if (main[link].quantity !== i.quantity) out.push({ key: i.key, quantity: main[link].quantity });
      } else if (isToeslag(i)) {
        if (!main[link]) out.push({ key: i.key, quantity: 0 });
        else if (main[link].quantity !== i.quantity) out.push({ key: i.key, quantity: main[link].quantity });
      }
    });
    return out;
  }
  window.ttCartPlan = plan;

  function sweep(list) {
    busy = true;
    return list.reduce(function (p, it) {
      return p.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: it.quantity })
        }).then(function (r) { if (!r.ok) throw new Error('change.js ' + r.status); });
      });
    }, Promise.resolve()).then(function () {
      window.location.reload();
    }).catch(function (e) {
      failed = true; busy = false;
      showError('Een toeslag of extra design kon niet worden bijgewerkt. Herlaad de pagina of haal de regel zelf weg.');
      if (window.console) console.error('tt-cart', e);
    });
  }

  function sync() {
    if (busy || failed) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); })
      .then(function (cart) {
        ship(cart);
        var o = plan(cart);
        if (o.length) sweep(o);
      })
      .catch(function (e) { if (window.console) console.error('tt-cart', e); });
  }

  function later() { clearTimeout(timer); timer = setTimeout(sync, 250); }

  function start() {
    later();
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(later);
    // Ride re-renders these two on every change; the ship section is outside them, so no feedback loop.
    ['cart-items', '#main-cart-footer'].forEach(function (sel) {
      var n = document.querySelector(sel);
      if (n) mo.observe(n, { childList: true, subtree: true });
    });
  }

  // 4. r19deellink: "Deel met je groep". The link comes ready from snippets/tt-zelfde-ontwerp.liquid (data-href); here only the group name is added.
  //    navigator.share when the device has it, otherwise copy and show "Link gekopieerd" in the page. Never an alert, confirm or modal.
  function cleanName(v) {
    var s = String(v || '').replace(/’/g, "'").replace(/[^\p{L}\p{N} '\-]/gu, '').replace(/\s+/g, ' ').trim().slice(0, 40).trim();
    return s === '1' ? '' : s; // "1" is the group panel switch (?groep=1), never a name
  }
  function nameOf(box) { return cleanName((box.querySelector('[data-tt-ds-naam]') || {}).value); }
  function shareLink(box) {
    var u = new URL(box.getAttribute('data-href'), window.location.origin), n = nameOf(box);
    if (n) u.searchParams.set('groep', n); else u.searchParams.delete('groep');
    return u.href;
  }
  function say(box, text) {
    var ok = box.querySelector('[data-tt-ds-ok]');
    if (!ok) return;
    ok.textContent = text; ok.hidden = false;
    clearTimeout(ok._t); ok._t = setTimeout(function () { ok.hidden = true; }, 6000);
  }
  function copyText(t) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(t);
    return new Promise(function (res, rej) {
      var a = document.createElement('textarea'), done = false;
      a.value = t; a.setAttribute('readonly', ''); a.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
      document.body.appendChild(a); a.select();
      try { done = document.execCommand('copy'); } catch (e) { done = false; }
      document.body.removeChild(a);
      if (done) res(); else rej(new Error('copy'));
    });
  }
  function onShare(box) {
    var url = shareLink(box), name = nameOf(box);
    var text = (name ? 'Bestel mee met ' + name : 'Bestel hetzelfde ontwerp') + ' bij TripleThread. Kies alleen je kleur en maat.';
    function fallback() {
      copyText(url).then(function () { say(box, 'Link gekopieerd'); }, function () { say(box, 'Kopieer deze link zelf: ' + url); });
    }
    if (navigator.share) {
      navigator.share({ title: 'Bestel mee bij TripleThread', text: text, url: url }).catch(function (e) {
        if (e && e.name === 'AbortError') return; // the customer closed the share sheet: nothing to say
        fallback();
      });
    } else fallback();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tt-ds-knop]'), box = b && b.closest('[data-tt-ds]');
    if (box) onShare(box);
  });
  window.ttDeelLink = shareLink;

  // 5. r21wagen: bar fixed to the bottom on phones while the real Afrekenen button is out of view (css: assets/tt-cart-layout.css, html.tt-sticky-on without html.tt-co-seen).
  function startSticky() {
    var real = document.getElementById('checkout');
    if (!real || !('IntersectionObserver' in window)) return;
    var root = document.documentElement;
    new IntersectionObserver(function (es) {
      root.classList.toggle('tt-co-seen', es[es.length - 1].isIntersecting);
    }).observe(real);
    root.classList.add('tt-sticky-on');
  }

  // "Wijzig": remove this garment line with its extra-design and surcharge lines (same _tt_link), then open the product page. Any failure: just open the page.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-tt-wijzig]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    if (a.getAttribute('aria-busy') === 'true') return;
    a.setAttribute('aria-busy', 'true');
    var key = a.getAttribute('data-key'), link = a.getAttribute('data-link'), go = function () { window.location.href = a.href; };
    busy = true; // keep the sweep above from reacting while the lines go
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); })
      .then(function (cart) {
        var keys = [key];
        if (link) cart.items.forEach(function (i) { if (i.key !== key && i.properties && i.properties._tt_link === link) keys.push(i.key); });
        return keys.reduce(function (p, k) {
          return p.then(function () {
            return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: k, quantity: 0 }) });
          });
        }, Promise.resolve());
      })
      .then(go, go);
  });

  function begin() { start(); startSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin); else begin();
})();
